import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';

import HomePage from '../pages/Home/HomePage';
import RegisterPage from '../pages/Auth/RegisterPage';
import LoginPage from '../pages/Auth/LoginPage';
import ReservationPage from '../pages/Reservation/ReservationPage';
import ReservationDetailPage from '../pages/Reservation/ReservationDetailPage';
import ProfilePage from '../pages/Profile/ProfilePage';
import LogoutTestPage from '../pages/Test/LogoutTestPage';
import ReservationManagementPage from '../pages/Admin/ReservationManagementPage';
import CreateAdminPage from '../pages/Admin/CreateAdminPage';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import TermsOfService from '../pages/legal/TermsOfService';

import styles from './styles/AppRoutes.module.css';

function LoadingPage() {
    return (
        <div className={styles.loadingContainer}>
            <div className={styles.loadingContent}>
                <FaSpinner className={styles.loadingIcon} />
                <p className={styles.loadingText}>Chargement...</p>
            </div>
        </div>
    );
}

function ProtectedRoute({ children }) {
    const { user, loading } = useContext(AuthContext);

    if (loading) return <LoadingPage />;
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default function AppRoutes() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/login" element={<LoginPage />} />

                <Route
                    path="/reservation"
                    element={
                        <ProtectedRoute>
                            <ReservationPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/reservation/:id"
                    element={
                        <ProtectedRoute>
                            <ReservationDetailPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/profile"
                    element={
                        <ProtectedRoute>
                            <ProfilePage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/admin/reservations"
                    element={
                        <ProtectedRoute>
                            <ReservationManagementPage />
                        </ProtectedRoute>
                    }
                />

                <Route path="/test-logout" element={<LogoutTestPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />

                {/* Admin */}
                <Route path="/admin/create-admin" element={<CreateAdminPage />} />
                <Route path="/admin/reservations" element={<ReservationManagementPage />} />

                {/* Legal */}
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
        </Router>
    );
}
